export default __webpack_public_path__ + "static/media/round_table.f55a50e9.png";